import React, { useCallback } from "react";
import { ArrowNavRightIcon, HistoryRecentIcon } from "@bookingcom/bui-assets-react/streamline";
import { Icon, ListItem, Stack, Text } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { MULTISTOP_IATA_LIST_SEPARATOR, PARAM_LIST_SEPARATOR } from "../../constants/params.js";
import styles from "./RecentSearchList.module.css";
const isValidDateString = (str) => !isNaN(Date.parse(str));
const getDate = (item, formats, _i18n) => {
    const depart = typeof item.depart === "string" && item.depart && isValidDateString(item.depart) ? item.depart : undefined;
    const returnDate = typeof item.return === "string" && item.return && isValidDateString(item.return) ? item.return : undefined;
    const isroundTripDates = !!depart && !!returnDate;
    const isOneWayDate = !isroundTripDates && !!depart;
    if (!isOneWayDate && !isroundTripDates)
        return undefined;
    return isOneWayDate ? formats.flightDate(depart) : formats.flightDateRange(depart, returnDate);
};
const getTraveller = (item, i18n) => {
    const adults = item.adults;
    if (!adults)
        return undefined;
    const children = item.children || "";
    const count = Number(adults) + Number(children.split(",").filter((a) => a !== "").length);
    return i18n.trans(t("flights_continue_search_card_travellers", {
        num_exception: count,
        variables: { num_travellers: count }
    }));
};
const getTripType = (item, i18n) => {
    const type = item.type;
    if (!type)
        return undefined;
    return type === "ONEWAY"
        ? i18n.trans(t("flights_continue_search_card_one_way"))
        : type === "ROUNDTRIP"
            ? i18n.trans(t("flights_continue_search_card_round_trip"))
            : i18n.trans(t("flights_continue_search_card_multi"));
};
const getTitle = (item, i18n) => {
    const fromLocationName = (item.fromLocationName || "").split(MULTISTOP_IATA_LIST_SEPARATOR);
    const toLocationName = (item.toLocationName || "").split(MULTISTOP_IATA_LIST_SEPARATOR);
    if (!fromLocationName.filter((a) => Boolean(a)).length)
        return undefined;
    if (!toLocationName.filter((a) => Boolean(a)).length)
        return undefined;
    const titleList = fromLocationName.map((fromItem, idx) => {
        const originCity = fromItem
            .split(PARAM_LIST_SEPARATOR)
            .join(`${i18n.trans(t("flights_continue_search_multi_separator"))} `);
        const destinationCity = toLocationName[idx]
            ?.split(PARAM_LIST_SEPARATOR)
            .join(`${i18n.trans(t("flights_continue_search_multi_separator"))} `);
        if (!originCity && !destinationCity)
            return undefined;
        return i18n.trans(t("flights_continue_search_card_title", {
            variables: { origin_city: originCity, destination_city: destinationCity }
        }));
    });
    if (!titleList.filter((a) => Boolean(a)).length)
        return undefined;
    let title = titleList.splice(0, 2).join(`${i18n.trans(t("flights_continue_search_multi_separator"))} `);
    if (titleList.length) {
        title = `${title} ${i18n.trans(t("flights_continue_search_multi_last", { variables: { num_flights: titleList.length } }))}`;
    }
    return title;
};
const getSubtitle = (item, formats, i18n) => {
    const formattedDate = getDate(item, formats, i18n);
    const travellersCount = getTraveller(item, i18n);
    const tripType = getTripType(item, i18n);
    if (!formattedDate || !travellersCount || !tripType)
        return undefined;
    return `${formattedDate} · ${travellersCount} · ${tripType}`;
};
const RecentSearchList = (props) => {
    const { recentSearchHistory, i18n, formats, onSelect, onFinish } = props;
    const handleClick = useCallback((search) => {
        onSelect(search);
        onFinish();
    }, [onSelect, onFinish]);
    const validSearches = recentSearchHistory
        .map((search) => ({
        search,
        title: getTitle(search, i18n),
        subtitle: getSubtitle(search, formats, i18n)
    }))
        .filter((item) => !!item.title && !!item.subtitle);
    if (!validSearches.length)
        return null;
    return (React.createElement(Stack, { direction: "column", className: styles.wrapper, gap: 0 },
        React.createElement(Stack.Item, null,
            React.createElement(Text, { color: "neutral_alt", variant: "emphasized_2" }, i18n.trans(t("flights_cat_search_continue")))),
        validSearches.map((item, idx) => (React.createElement(ListItem, { key: idx, startSlot: React.createElement(Stack, { className: styles.iconWrapper },
                React.createElement(Icon, { svg: HistoryRecentIcon, size: "small" })), endSlot: React.createElement(Icon, { svg: ArrowNavRightIcon, size: "medium" }), onClick: () => handleClick(item.search), className: styles.listItem },
            React.createElement(Stack, { direction: "column", gap: 0 },
                React.createElement(Text, { variant: "strong_2", tagName: "strong" }, item.title),
                React.createElement(Text, { color: "neutral_alt", variant: "body_2", className: styles.subTitle }, item.subtitle)))))));
};
export default RecentSearchList;
